module.exports = __webpack_public_path__ + "static/media/IMG-4.7df138a7.jpg";